import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import DraftRendererWithOptions from '../DraftRenderer';

import './side-panel.scss';
import './side-panel-typography.scss';

class SidePanel extends PureComponent {
  state = {
    opened: false
  };

  componentDidMount() {
    document.body.addEventListener('click', this.layoutClickHandler);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      if (!nextProps.open) {
        document.documentElement.classList.remove('nav-open');
      } else {
        this.panel.childNodes[0].scrollTop = 0;
        document.documentElement.classList.add('nav-open');
      }

      this.setState({ open: nextProps.open });
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.layoutClickHandler);
  }

  layoutClickHandler = (event) => {
    if (!this.state.open) {
      return;
    }

    if (!this.panel.contains(event.target)) {
      if (event) {
        event.stopPropagation();
      }

      this.props.onCloseClick();
    }
  };

  render() {
    const { open } = this.state;

    return (
      <div ref={elem => { this.panel = elem; }}>
        <div className={cn('side-panel panel-typography', { open })}>
          <div className="side-panel-scroll">
            <div className="static-section">
              <button
                className="side-panel-close"
                type="button"
                onClick={this.props.onCloseClick}
              />
            </div>

            {(!!this.props.content) &&
              <DraftRendererWithOptions
                content={JSON.stringify(this.props.content)}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

SidePanel.propTypes = {
  open: PropTypes.bool.isRequired,
  content: PropTypes.object,
  onCloseClick: PropTypes.func
};

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/widgets/SidePanel/index.js